import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ReactHowler from 'react-howler';

import RecordConfirmSetupModal from './RecordConfirmSetupModal';

import utils from '../../lib/utils';
import './index.scss';

export default class AddVoiceGreeting extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      recordConfirmModalVisibility: false,
      recorderCommand: 'none',
      audio: {},
      isAudioLoaded: false,
      isPlaying: false,
      isRecording: false,
      resetSuccess: false,
      isUploadingAudio: false,
      isGreetingSaveInProgress: false,
      hasRecordingPermission: false,
      isRecordingSupported: utils.isAudioRecordingSupported(),
    };

    this.player = null;
    this.recorder = null;
    this.audio_context = null;

    this.onRecordClick = this.onRecordClick.bind(this);
    this.onPlayClick = this.onPlayClick.bind(this);
    this.onRecordingComplete = this.onRecordingComplete.bind(this);
    this.onRecordConfirm = this.onRecordConfirm.bind(this);
    this.onRecordCancel = this.onRecordCancel.bind(this);
    this.onNextClick = this.onNextClick.bind(this);
    this.onResetClick = this.onResetClick.bind(this);
    this.onFileUpload = this.onFileUpload.bind(this);
    this.onAudioPlayEnd = this.onAudioPlayEnd.bind(this);
    this.onAudioLoaded = this.onAudioLoaded.bind(this);
  }

  componentDidMount() {
    this.props.getGreeting();

    try {
      // webkit shim
      window.AudioContext = window.AudioContext || window.webkitAudioContext;
      navigator.getUserMedia =
        navigator.getUserMedia ||
        navigator.mozGetUserMedia ||
        navigator.msGetUserMedia ||
        navigator.webkitGetUserMedia;
      window.URL = window.URL || window.webkitURL;

      this.audio_context = new AudioContext(); // eslint-disable-line new-parens
      console.log('Audio context set up.');
    } catch (e) {
      console.log('No web audio support in this browser!');
    }

    const onSuccess = (stream) => {
      const input = this.audio_context.createMediaStreamSource(stream);
      console.log('Media stream created.');

      this.recorder = new window.Recorder(input);
      console.log('Recorder initialised.');

      this.setState({
        hasRecordingPermission: true,
      });
    };

    if (navigator.getUserMedia) {
      navigator.getUserMedia({ audio: true }, onSuccess, (e) => {
        console.log(`No live audio input: ${e}`);

        this.setState({
          hasRecordingPermission: false,
        });
      });
    } else if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      // Safari 11.x
      navigator.mediaDevices.getUserMedia({ audio: true })
      .then(function(mediaStream){
        onSuccess(mediaStream);
      }).catch( (e) => {
        console.log(`No live audio input: ${e}`);
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const newState = {};
    let stateCallback = () => {};

    if (
      nextProps.greeting.isResetSuccess &&
      !this.props.greeting.isResetSuccess
    ) {
      newState.resetSuccess = true;
      stateCallback = () => {
        setTimeout(() => {
          this.props.getGreeting();
        }, 2000);
      };
    } else {
      newState.resetSuccess = false;
    }

    if (
      nextProps.greeting.audio &&
      this.props.greeting.audio !== nextProps.greeting.audio
    ) {
      newState.isGreetingSaveInProgress = false;
      newState.isUploadingAudio = false;
    }

    this.setState(newState, stateCallback);
  }

  componentWillUnmount() {
    this.setState({
      isPlaying: false,
    });
  }

  onAudioLoaded() {
    this.setState({
      isAudioLoaded: true,
    });
  }

  onRecordClick() {
    if (this.state.isPlaying) {
      return;
    }

    if (this.state.recorderCommand === 'start') {
      this.setState(
        {
          recorderCommand: 'stop',
          isGreetingSaveInProgress: true,
        },
        () => {
          if (this.recorder) {
            this.recorder.stop();

            this.onRecordingComplete();

            this.recorder.clear();
          }
        },
      );
    } else {
      this.setState({
        recordConfirmModalVisibility: true,
      });
    }
  }

  onRecordConfirm() {
    this.setState(
      {
        recordConfirmModalVisibility: false,
        recorderCommand: 'start',
      },
      () => {
        if (this.recorder) {
          this.recorder.record();
        }
      },
    );
  }

  onRecordCancel() {
    this.setState({
      recordConfirmModalVisibility: false,
    });
  }

  onPlayClick() {
    if (!this.player) return;

    if (this.state.recorderCommand === 'start') {
      return;
    }

    if (this.state.isPlaying) {
      this.setState({
        isPlaying: false,
      });
    } else {
      this.setState({
        isPlaying: true,
      });
    }
  }

  onRecordingComplete() {
    if (this.recorder) {
      this.recorder.exportWAV((audio) => {
        // const url = URL.createObjectURL(audio);
        // this.dwnld.href = url;
        // this.dwnld.download = `${new Date().toISOString()}.wav`;

        this.setState(
          {
            audio,
          },
          () => {
            this.props.setGreeting(audio);
          },
        );
      });
    }
  }

  onResetClick(event) {
    event.stopPropagation();
    event.preventDefault();

    this.setState(
      {
        isGreetingSaveInProgress: true,
      },
      () => {
        this.props.resetGreeting();
      },
    );
  }

  onFileUpload(event) {
    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];
      this.setState(
        {
          isInvalidFile: false,
        },
        () => {
          const validationSuccess = () => {
            this.setState(
              {
                isUploadingAudio: true,
              },
              () => {
                this.props.setGreeting(file);
              },
            );
          };

          if (typeof FileReader !== 'undefined') {
            const filereader = new FileReader();
            filereader.onloadend = (fileEvent) => {
              if (fileEvent.target.readyState === FileReader.DONE) {
                const uint = new Uint8Array(fileEvent.target.result);
                const bytes = [];
                uint.forEach((byte) => {
                  bytes.push(byte.toString(16));
                });
                const hex = bytes.join('').toUpperCase();
                const mimeType = utils.getMimetype(hex);

                if (mimeType === 'audio/mp3') {
                  validationSuccess();
                } else {
                  this.setState({
                    isInvalidFile: true,
                  });
                  // Show error message
                }
              }
            };
            const blob = file.slice(0, 4);
            filereader.readAsArrayBuffer(blob);
          } else {
            console.log(
              'FileReader API not supported. Skipping file validation!',
            );
            validationSuccess();
          }
        },
      );
    }
  }

  onNextClick() {
    if (this.state.isPlaying) {
      this.setState({
        isPlaying: false,
      });
    }

    this.props.onAddVoiceNextClick();
  }

  onAudioPlayEnd() {
    this.setState({
      isPlaying: false,
    });
  }

  render() {
    let playLabel = 'Listen to the current voice greeting';
    if (this.state.isPlaying) {
      playLabel = 'Playing...';
    }
    if (this.state.recorderCommand === 'start') {
      playLabel = '';
    }

    let recordLabel = (
      <div>
        Record a new voice greeting
        <p className="hint-text">Note: It will replace the old greeting</p>
      </div>
    );
    if (this.state.recorderCommand === 'start') {
      recordLabel = 'Recording...';
    }
    if (this.state.isPlaying) {
      recordLabel = '';
    }

    let resetLabel = 'Reset to default voice greeting';
    if (this.state.isPlaying || this.state.recorderCommand === 'start') {
      resetLabel = '';
    }

    let uploadLabel = (
      <div>
        Upload voice greeting
        <p className="hint-text">.mp3 file format</p>
      </div>
    );
    if (this.state.isPlaying || this.state.recorderCommand === 'start') {
      uploadLabel = '';
    } else if (this.state.isUploadingAudio) {
      uploadLabel = 'Uploading...';
    }

    return (
      <div className="add-voice-greeting">
        <p className="add-voice-greeting__text">
          Review your voicemail greeting, and if needed, record a new one
        </p>
        <div className="add-voice-greeting__audio-option">
          {/* <a ref={(c) => { this.dwnld = c; }}>Download</a> */}
          <div className="add-voice-greeting__audio-option__row">
            <div
              className={classnames('audio-icon', {
                'audio-icon--playing': this.state.isPlaying,
              })}
            >
              <button
                type="button"
                disabled={
                  this.state.recorderCommand === 'start' ||
                  this.state.isGreetingSaveInProgress ||
                  !this.state.isAudioLoaded
                }
                className={classnames('play-button', {
                  disabled:
                    this.state.recorderCommand === 'start' ||
                    this.state.isGreetingSaveInProgress ||
                    !this.state.isAudioLoaded,
                })}
                onClick={this.onPlayClick}
              >
                <i className="material-icons">{!this.state.isPlaying?'play_arrow':'stop'} </i>
              </button>
            </div>
            <div className="audio-text">{playLabel}</div>
          </div>
          <div
            className={classnames('add-voice-greeting__audio-option__row', {
              hide: !this.state.isRecordingSupported,
            })}
          >
            <div
              className={classnames('audio-icon', {
                'audio-icon--recording': this.state.recorderCommand === 'start',
              })}
            >
              <button
                type="button"
                onClick={this.onRecordClick}
                disabled={
                  this.state.isPlaying ||
                  this.state.isGreetingSaveInProgress ||
                  !this.state.hasRecordingPermission
                }
                className={classnames('recording-button', {
                  disabled:
                    this.state.isPlaying ||
                    this.state.isGreetingSaveInProgress ||
                    !this.state.hasRecordingPermission,
                })}
              >
                {this.state.recorderCommand !== 'start' ? (
                  <i className="material-icons">circle</i>
                ) : (
                  <i className="material-icons">square</i>
                )}
              </button>
            </div>
            <div className="audio-text">{recordLabel}</div>
          </div>
          <div className="add-voice-greeting__audio-option__row">
            <div className="audio-icon">
              <button
                type="button"
                disabled={
                  this.state.isPlaying ||
                  this.state.recorderCommand === 'start' ||
                  this.state.isGreetingSaveInProgress
                }
                className={classnames('reset-button', {
                  disabled:
                    this.state.isPlaying ||
                    this.state.recorderCommand === 'start' ||
                    this.state.isGreetingSaveInProgress,
                })}
                onClick={this.onResetClick}
              >
                <i className="material-icons">replay</i>
              </button>
            </div>
            <div className="audio-text">{resetLabel}</div>
          </div>
          <div className="add-voice-greeting__audio-option__row">
            <div className="audio-icon">
              <div className="upload-btn-wrapper">
                <button
                  disabled={
                    this.state.isPlaying ||
                    this.state.recorderCommand === 'start' ||
                    this.state.isGreetingSaveInProgress
                  }
                  className={classnames('upload-button', {
                    disabled:
                      this.state.isPlaying ||
                      this.state.recorderCommand === 'start' ||
                      this.state.isGreetingSaveInProgress,
                  })}
                >
                  <i className="material-icons">upload</i>
                </button>
                <input
                  type="file"
                  name="myfile"
                  accept=".mp3"
                  onChange={this.onFileUpload}
                />
              </div>
            </div>
            <div className="audio-text">{uploadLabel}</div>
            {this.state.isInvalidFile ? (
              <p className="message message--error">
                Please upload a valid .mp3 file
              </p>
            ) : null}
          </div>
          {this.state.resetSuccess ? (
            <p className="message message--success">
              Greeting reset successful
            </p>
          ) : null}
        </div>
        <RecordConfirmSetupModal
          visibility={this.state.recordConfirmModalVisibility}
          onConfirm={this.onRecordConfirm}
          onCancel={this.onRecordCancel}
        />
        {this.props.greeting.audio ? (
          <ReactHowler
            src={this.props.greeting.audio}
            playing={this.state.isPlaying}
            onEnd={this.onAudioPlayEnd}
            onLoad={this.onAudioLoaded}
            ref={(c) => {
              this.player = c;
            }}
          />
        ) : (
          undefined
        )}
      </div>
    );
  }
}

AddVoiceGreeting.defaultProps = {
  setGreeting: () => {},
  getGreeting: () => {},
  resetGreeting: () => {},
  onAddVoiceNextClick: () => {},
  greeting: {
    audio: null,
    isResetSuccess: false,
  },
};

AddVoiceGreeting.propTypes = {
  setGreeting: PropTypes.func,
  getGreeting: PropTypes.func,
  resetGreeting: PropTypes.func,
  onAddVoiceNextClick: PropTypes.func,
  greeting: PropTypes.shape({
    audio: PropTypes.any,
    isResetSuccess: PropTypes.bool,
  }),
};
